document.querySelectorAll(".js-cole-menu a").forEach(link => {
    let dataHandle = document.querySelector("[data-handle]")?.getAttribute("data-handle");
    if (dataHandle && link.getAttribute("href").includes(dataHandle)) {
        link.parentElement.classList.add("active");
    }
});

const filterSection = document.querySelector('.filters-section');
document.addEventListener('click', function (event) {
    const clickedLink = event.target.closest('a.change-collection');
    const changeSort = event.target.closest('a.change-sorting');
    const sortToggle = event.target.closest('.sort-click');
    const mobileToggle = event.target.closest('.swap-filter');
    const button = event.target.closest(".show-filter-set");
    const jscsub = event.target.closest(".jsc-sub");
    const rowswap = event.target.closest(".row-swap");

    if (jscsub) {
        event.preventDefault();
        document.body.classList.toggle('subactive');
    }
    else if (rowswap) {
        event.preventDefault();
        document.body.classList.toggle('mobsinglerow');
    }
    else if (clickedLink) //filter load
    {
        event.preventDefault();
        const url = new URL(clickedLink.href);
        fetchCollection(url,true);
        window.history.pushState(null, "", url);
    }else if (changeSort) //sort load
    {
        event.preventDefault();
        const sortValue = changeSort.getAttribute('href');
        const url = new URL(window.location.href);
        document.querySelector('.filters-section').classList.toggle('open-desk');
        url.searchParams.set('sort_by', sortValue);
        url.searchParams.delete('page');
        fetchCollection(url,true);
        window.history.pushState(null, "", url);
    }else if (sortToggle) //desktop open filter
    {
        event.preventDefault();
        sortToggle.closest('.sort-wrap')? sortToggle.closest('.sort-wrap').classList.toggle('open-filter'):false;

    }else if (mobileToggle) //desktop open filter
    {
        event.preventDefault();
        document.querySelector('body').classList.toggle('mobile-filter');
        document.querySelector('html').classList.toggle('mobile-filter');
    }
    else if (button) //desktop open filter
    {
        event.preventDefault();
        const filterSet = button.closest(".filter-set"); // Find the parent .filter-set
        if (!filterSet) return;

        const dataViewElement = filterSet.querySelector("[data-view]"); // Find the child with [data-view]
        if (!dataViewElement) return;

        const dataViewValue = dataViewElement.getAttribute("data-view"); // Get 'data-view' value

        const bottomElement = document.querySelector(".jsc-bottom"); // Find .jsc-bottom
        if (bottomElement) {
            bottomElement.setAttribute("data-show", dataViewValue); // Set 'data-show' attribute
        }

        // Smoothly scroll to the parent .filter-set
        filterSet.scrollIntoView({ behavior: "smooth", block: "start" });
    }else
    {
        return;
    }
});
/*
document.querySelector(".sort-wrap")?.addEventListener("mouseleave", () => {
    document.querySelector(".sort-wrap")?.classList.remove("open-filter");
});*/

if (!document.querySelector('.left-filter .filter-set')) {
    document.querySelector('.left-filter').style.visibility = 'hidden';
}


function fetchCollection(url,filter)
{
    const queryString = url.search.slice(1);
    const mainurl = url.toString().split("?")[0];
    const requestUrl = `${mainurl}/?section_id=zpro-collection&${queryString}`;

    // Fetch the content
    fetch(requestUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            // Create a temporary DOM element to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Extract and insert content for the '.collection' class
            const collectionContent = tempDiv.querySelector('.filter-ajax');
            if (collectionContent) {
                const collectionWrap = document.querySelector('.filter-ajax');
                if (collectionWrap) {
                    collectionWrap.innerHTML = collectionContent.innerHTML;
                }
            }

            // Extract and insert content for the '.collection' class
            const collectionFilter = tempDiv.querySelector('.left-filter');
            if (collectionFilter) {
                const collectionFilterWrap = document.querySelector('.left-filter');
                if (collectionFilterWrap) {
                    collectionFilterWrap.innerHTML = collectionFilter.innerHTML;
                }
            }

            // Extract and insert content for the '.filter' class

            const filterContent = tempDiv.querySelector('collectionload');
            if (filterContent) {
                const filterWrap = document.querySelector('collectionload');
                if (filterWrap) {
                    filterWrap.innerHTML = filterContent.innerHTML;
                }
            }

            window.scrollTo(0, 0);
            window.yotpo.refreshWidgets(); // review update
            let elem = document.querySelector(".spi-reviewwrap"); //slider social
            if (elem) new Flickity(elem, { cellAlign: "center", pageDots: false, prevNextButtons: true, contain: true, groupCells: true, rightToLeft: false });

        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
}

//next page
document.addEventListener('click', function (event) {
    const clickedLink = event.target.closest('a.collection-next');
    if (!clickedLink) return;

    const newUrl = clickedLink.href;
    event.preventDefault();
    window.history.pushState(null, "", newUrl);
    clickedLink.textContent = 'LOADING...';

    // Fetch content from the new URL
    fetch(newUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            const newProducts = tempDiv.querySelector('.jlc-products');
            if (newProducts) {
                const currentProducts = document.querySelector('.jlc-products');
                if (currentProducts) {
                    currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                }
            }

            const newPagination = tempDiv.querySelector('.jl-pagination');
            if (newPagination) {
                const currentPagination = document.querySelector('.jl-pagination');
                if (currentPagination) {
                    currentPagination.innerHTML = newPagination.innerHTML;
                }
            }
        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
});


document.addEventListener("DOMContentLoaded", function () {
    let isThrottled = false; // Flag to control the delay

    // Function to check if an element is in the viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Scroll event listener | disabled
    /*
    window.addEventListener("scroll", function () {
        if (isThrottled) return; // Skip execution if throttled

        const nextButton = document.querySelector(".collection-next");

        if (nextButton && isInViewport(nextButton)) {
            nextButton.click(); // Automatically click the button
            console.log("call");
            isThrottled = true; // Set throttle flag

            // Reset the throttle flag after 4 seconds
            setTimeout(() => {
                isThrottled = false;
            }, 1000);
        }
    });*/
});

document.addEventListener("DOMContentLoaded", function() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("subs") === "true") {
        document.body.classList.add("subactive");
    }
});


